/**
 * Application Configuration
 *
 * Centralized configuration for the Cloud Landing Platform
 */

export const APP_CONFIG = {
  /**
   * Product name shown in the browser tab and sidebar branding.
   * Configured via VITE_APP_NAME (GitHub environment variable APP_NAME).
   */
  APP_NAME: import.meta.env.VITE_APP_NAME || 'Landing.com',

  /**
   * Sites domain for all deployed sites
   * Sites will be deployed as: {subdomain}.{SITES_DOMAIN}
   * Configured via VITE_SITES_DOMAIN environment variable
   */
  SITES_DOMAIN: import.meta.env.VITE_SITES_DOMAIN || 'localhost:3001',

  /**
   * API Base URL
   * Can be overridden by VITE_API_BASE_URL environment variable
   */
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001',

  /**
   * Default environment
   */
  DEFAULT_ENVIRONMENT: 'production' as const,

  /**
   * Status refresh interval (ms)
   * How often to poll for status updates
   */
  STATUS_REFRESH_INTERVAL: 30000, // 30 seconds
} as const;

export default APP_CONFIG;
